import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

const BlobStorageSummary = ({ summary, overallStatus }) => {
    const getOverallStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'healthy':
            case 'connected':
                return 'text-green-500';
            case 'partially connected':
            case 'degraded':
                return 'text-yellow-500';
            case 'unhealthy':
            case 'disconnected':
                return 'text-red-500';
            default:
                return 'text-gray-500';
        }
    };

    const getOverallStatusIcon = (status) => {
        switch (status?.toLowerCase()) {
            case 'healthy':
            case 'connected':
                return 'mdi:check-circle';
            case 'partially connected':
            case 'degraded':
                return 'mdi:alert-circle';
            case 'unhealthy':
            case 'disconnected':
                return 'mdi:close-circle';
            default:
                return 'mdi:help-circle';
        }
    };

    if (!summary) {
        return null;
    }

    return (
        <div className="rounded flex flex-col gap-3 p-1">
            <div className="flex items-center gap-2 text-base">
                <Icon 
                    icon={getOverallStatusIcon(overallStatus)} 
                    className={`text-2xl ${getOverallStatusColor(overallStatus)}`} 
                />
                <h5 className="font-semibold text-font-primary text-base">Blob Storage Summary</h5>
            </div>

            <hr className='border-border' />
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="text-center">
                    <div className="text-2xl font-bold text-font-primary">
                        {summary.totalAccounts || 0}
                    </div>
                    <div className="text-xs text-font-secondary">Total Accounts</div>
                </div>
                
                <div className="text-center">
                    <div className="flex items-center justify-center gap-1 text-2xl font-bold text-green-500">
                        <Icon icon="mdi:check-circle" className="text-lg" />
                        {summary.connectedAccounts || 0}
                    </div>
                    <div className="text-xs text-font-secondary">Connected</div>
                </div>
                
                <div className="text-center">
                    <div className="flex items-center justify-center gap-1 text-2xl font-bold text-red-500">
                        <Icon icon="mdi:close-circle" className="text-lg" />
                        {summary.disconnectedAccounts || 0}
                    </div>
                    <div className="text-xs text-font-secondary">Disconnected</div>
                </div>
                
                <div className="text-center">
                    <div className="flex items-center justify-center gap-1 text-2xl font-bold text-yellow-500">
                        <Icon icon="mdi:alert-circle" className="text-lg" />
                        {summary.notConfiguredAccounts || 0}
                    </div>
                    <div className="text-xs text-font-secondary">Not Configured</div>
                </div>
            </div>
            
            {/* Status Bar */}
            <div className="mt-3">
                <div className="flex items-center justify-between text-xs text-font-secondary mb-1">
                    <span>Connection Status</span>
                    <span className={`font-semibold ${getOverallStatusColor(overallStatus)}`}>
                        {overallStatus}
                    </span>
                </div>
                <div className="w-full bg-gray-700 rounded-md h-2">
                    <div 
                        className={`h-2 rounded-md transition-all duration-300 ${
                            overallStatus?.toLowerCase() === 'healthy' || overallStatus?.toLowerCase() === 'connected'
                                ? 'bg-green-500'
                                : overallStatus?.toLowerCase() === 'partially connected' || overallStatus?.toLowerCase() === 'degraded'
                                    ? 'bg-yellow-500'
                                    : 'bg-red-500'
                        }`}
                        style={{
                            width: summary.totalAccounts > 0 
                                ? `${((summary.connectedAccounts || 0) / summary.totalAccounts) * 100}%`
                                : '0%'
                        }}
                    ></div>
                </div>
            </div>
        </div>
    );
};

export default BlobStorageSummary;
